import { createContext, type PropsWithChildren } from "react";
import type { ApplicationDetailProviderProps } from "./types";
import useApplicationDetail from "./useApplicationDetail";

export const ApplicationDetailContext = createContext({} as ReturnType<typeof useApplicationDetail>);

const ApplicationDetailProvider = ({ children, ...restProps }: PropsWithChildren<ApplicationDetailProviderProps>) => (
    <ApplicationDetailContext.Provider
        value={useApplicationDetail(restProps)}
    >
        {children}
    </ApplicationDetailContext.Provider>
);

export default ApplicationDetailProvider;
